<template>
  <el-container
    class="login"
    v-loading="isLoading"
    element-loading-text="登录中..."
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <video playsinline="" autoplay="" muted="" loop="" class="bgvid" id="bgvid">
      <source src="~@/assets/images/login/bg.mp4" type="video/mp4" />
    </video>
    <!-- <div class="animateBox">
      <div class="animateCount">
        <div class="countChildren">
          <div class="childer">2222</div>
        </div>
      </div>
    </div> -->
    <div class="loginTitle">
      <img v-if="islgoinList" alt="Vue" src="~@/assets/images/login/logo.png" />
      <img v-else alt="Vue" src="~@/assets/images/login/logo2.png" />
    </div>
    <div v-if="lgoinLabelList" class="ridorClick">
      <div
        v-for="(item, index) in listData"
        :key="index"
        @click="handleClick(item, index)"
        class="btn"
        :class="active === index ? 'active' : ''"
      >
        {{ item.title }}
      </div>
    </div>
    <div class="login-box">
      <div class="login-item account">
        <img
          class="icontitle"
          alt="Vue"
          src="~@/assets/images/login/login.png"
        />
        <el-input
          v-model="account"
          @keyup.enter="loginClick"
          placeholder="请输入账号"
          autofocus
        ></el-input>
      </div>
      <div class="login-item password">
        <img
          class="icontitle"
          alt="Vue"
          src="~@/assets/images/login/pswd.png"
        />
        <el-input
          v-model="password"
          @keyup.enter="loginClick"
          placeholder="请输入密码"
          show-password
        ></el-input>
      </div>
      <div class="btn-login">
        <span class="btn-login-span" @click="loginClick">登录</span>
      </div>
    </div>
    <div class="checkboxlogin">
      <el-checkbox v-model="checked">记住用户名</el-checkbox>
      <span @click="downFile">
        <h-icon icon="icon-xiazai" font-size="14"></h-icon>
        下载中心</span
      >
    </div>
  </el-container>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  onBeforeUpdate,
  onUpdated,
  // onBeforeUnmounted, // 组件销毁前
  // onUnmounted, // 组件销毁
  // onActiveted, // 条件:<keep-alive>
  // onDeActiveted, // 条件:<keep-alive>
  // onErrorCaptured, // 当捕获一个来自子孙组件的异常时激活
  // onRenderTracked // 跟踪状态变化 返回event所有变化属性
  // onRenderTriggered // 跟踪状态变化 返回event单个主要变化属性
  // watch // watch([()=>data.要监听的属性,...监听多个属性],(newValue,oldValue)=>{})
} from "vue";
import * as api from "@/api/login";
import { useRouter } from "vue-router";
// import { storage } from "@/utils/library/storage";
import { ElMessage } from "element-plus";
import util from "@util/js";
export default defineComponent({
  name: "login",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      islgoinList: window.lgoinList,
      lgoinLabelList: window.lgoinLabelList,
      account: "",
      password: "",
      checked: false,
      isLoading: false,
      active: "",
      listData: [
        {
          title: "智慧安防小区模块",
        },
        {
          title: "娱乐场所和特种行业模块",
        },
        {
          title: "智慧公安检查站模块",
        },
        {
          title: "智慧内保模块",
        },
      ],
    });
    const refData = toRefs(data);
    const router = useRouter();
    onBeforeMount(() => {});
    onMounted(() => {
      console.log(router);
      if (router.currentRoute.value.query.idCard) {
        data.isLoading = true;
        api
          .cardLogin({ idCard: router.currentRoute.value.query.idCard })
          .then((res) => {
            data.isLoading = false;
            const token = res.token;
            util.setStorage("token", token);
            util.setStorage("username", res.username);
            util.setStorage("name", res.name);
            util.setStorage("userDeptId", res.deptId);
            router.push(window.routerPush);
          });
      }
    });
    onBeforeUpdate(() => {});
    onUpdated(() => {});
    const loginClick = async () => {
      const dataObj = {
        username: data.account,
        password: data.password,
      };
      if (!(data.account && data.password)) {
        ElMessage.error({
          message: "请输入账号和密码",
        });
      } else {
        api.login(dataObj).then((res) => {
          // if (res.code === "200") {
          // const data = res.data;
          // this.setStorageUserInfo(data);
          // const CUSNUMBER = data.userInfo.cusNumber
          const token = res.token;
          util.setStorage("token", token);
          util.setStorage("username", res.username);
          util.setStorage("name", res.name);
          util.setStorage("userDeptId", res.deptId);
          // storage.setItem("JWT", JWT);
          // storage.setItem("token", token);
          // storage.setItem("CANUSEVIDEO", CANUSEVIDEO);
          // storage.setItem("ISADMIN", ISADMIN);
          // storage.setItem("USERID", USERID);
          // storage.setItem("USERNAME", USERNAME);
          // storage.setItem("CUSNAME", CUSNAME);
          // storage.setItem("CUSNUMBER", CUSNUMBER);
          // storage.setItem("AREAINFO", AREAINFO);
          // storage.setItem("ROLEKEY", ROLEKEY);
          // storage.setItem("NICKNAME", NICKNAME);
          // storage.setItem("BUTTONINFO", BUTTONINFO);

          router.push(window.routerPush);
          // } else {
          //   this.$message.error({
          //     message: res.message
          //   });
          // }
        });
      }
    };
    const handleClick = (item, index) => {
      if (data.active === index) {
        data.active = "";
      } else {
        data.active = index;
        localStorage.setItem("active", item.title);
      }
    };
    const downFile = () => {
      router.push("downCenter");
    };
    // onRenderTracked((event) => {console.log(event)})
    // watch([() => data],(newValue,oldValue) => {})
    return { ...refData, loginClick, handleClick, downFile };
  },
});
</script>
<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100%;
  background: url("~@/assets/images/login/bg.mp4") no-repeat center 0px;
  background-size: 100% 100%;
  position: relative;
  #bgvid {
    position: fixed;
    right: 0;
    bottom: 0;
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
    z-index: -100;
    background-size: cover;
  }
  .loginTitle {
    position: absolute;
    width: 55%;
    margin: auto;
    top: 25%;
    left: 0;
    right: 0;
    img {
      width: 100%;
    }
  }
  .ridorClick {
    position: absolute;
    width: 800px;
    height: 10vh;
    margin: auto;
    top: 42%;
    left: 0px;
    right: 0;
    display: flex;
    margin-bottom: 10px;
  }
  .login-box {
    width: 800px;
    height: 10vh;
    position: fixed;
    left: 0;
    right: 0;
    margin: auto;
    top: 47%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .login-item {
      width: 300px;
      position: relative;
      display: flex;
      align-items: center;
      // height: 10vh;
      // display: flex;
      // justify-content: flex-end;
      // align-items: center;
      .icontitle {
        position: absolute;
        z-index: 10;
        left: 5px;
        width: 16px;
      }
      .el-input__inner {
        -webkit-appearance: none;
        background-color: transparent !important;
        background-image: none;
        display: inline-block;
        font-size: inherit;
        height: 100%;
        line-height: 100%;
        outline: 0;
        width: 100%;
        padding-left: 20px !important;
        margin-left: 25%;
      }
      /deep/ input {
        background-color: #1e3d6d !important;
        outline: none;
        border: 0px;
        height: 42px;
        padding-left: 28px;
        color: #fff;
      }
      ::-webkit-input-placeholder {
        color: white;
      }
      /deep/ .el-input .el-input__clear {
        color: #4469ce;
        font-size: 16px;
      }
    }
  }
  .btn-login {
    cursor: pointer;
    span {
      display: flex;
      padding: 0 36px;
      line-height: 42px;
      background: #263bd9;
      border-radius: 4px;
      color: #fff;
    }
  }
  .checkboxlogin {
    @include flex-row-s-c;
    position: absolute;
    width: 800px;
    margin: auto;
    top: 54%;
    left: 0;
    right: 0;
    /deep/ .el-checkbox {
      color: #fff;
    }
    span {
      margin-left: 258px;
      font-size: 14px;
      color: #fff;
      cursor: pointer;
    }
  }
}
.animateBox {
  width: 100%;
  height: 100%;
  position: fixed;
  // background: #fff;
  // opacity: 0.2;
  // perspective:1000px;
  // -webkit-perspective:1000px; /* Safari and Chrome */
  .animateCount {
    width: 100%;
    height: 50%;
    position: absolute;
    // border: 1px solid black;
    // background-color: yellow;
    transform: rotateX(150deg);
    -webkit-transform: rotateX(150deg); /* Safari and Chrome */
    perspective: 1000px;
    -webkit-perspective: 1000px; /* Safari and Chrome */
    @keyframes flyin {
      0% {
        transform: translateZ(1200px);
      }
      100% {
        transform: translateZ(-1500px);
      }
    }
    .countChildren {
      position: absolute;
      transform-style: preserve-3d;
      transform: translateZ(1000px);
      animation: flyin infinite linear;
      top: 4vh;
      left: 1vw;
      animation-delay: 100ms;
      animation-duration: 5s;
      width: 100px;
      height: 100px;
      // background-color:#fff;
      background: rgba(10, 37, 80, 1);
      .childer {
        // width: 100px;
        // height: 100px;
        // background:#00f;
        // color:#fff;
      }
      &:nth-child(1) {
      }
    }
  }
}
.btn {
  cursor: pointer;
  position: relative;
  color: #fff;
  width: 180px;
  height: 50px;
  margin: 0 10px;
  text-align: center;
  line-height: 50px;
  background-color: rgba(255, 255, 255, 0);
  background-image: url("~@/assets/images/0303/menu2.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  &.active {
    color: #fff;
    background-color: rgba(255, 255, 255, 0);
    background-image: url("~@/assets/images/0303/menu1.png");
    background-repeat: no-repeat;
  }
}
</style>
